import React from 'react'
import PropTypes from 'prop-types'
import cn from 'comma-number'

import { SL_GATE } from 'Defaults/modals'
import BlurCont from 'Layout/BlurCont'

import ListingRemovalMessage from 'Components/ListingRemovalMessage'
import ListingPreviewLockedText from 'Components/ListingPreviewLockedText'

import { InfoHolderLocked, ImgPreview } from '../index'
import {
  _Locked, _LockedImgBox,
  _PreviewContent, _AskingPrice,
  _AddressHolder, _AddressTitle, _Link, _ListingRemovalMessageContainer,
} from './styles'


const Locked = ({
  hiddenFields,
  onLogin,
  imageSrc,
  url,
  onRegister,
  openNewTab,
  title,
  onHover,
  onMouseLeave,
  askingPrice,
  slogan,
  isSold,
  building,
  unitNumber,
  isArchived,
  closedPrice,
  userIsLoggedIn,
  openEmailVerifyModal,
  requiredEmailVerification,
  source,
  requireTermsConditionAgreement,
  onTermsConditionClick,
}) => {
  // if user is login -> and requires email verification or terms condition open required modal
  const infoAskingPrice = !isSold ? (isArchived ? closedPrice : askingPrice) : slogan || building || 'SOLD'
  const openSignupOnLockedImageClick = () => {
    onRegister({
      gate: SL_GATE.LISTING_CARD_IMAGE,
    })
  }

  const openSignupOnListingInfo = () => {
    onRegister({
      gate: SL_GATE.LISTING_CARD_INFO,
    })
  }
  const onLockedClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }

  return (
    <_Locked
      data-test-id="listingPreviewLocked"
      onMouseEnter={onHover}
      onMouseLeave={onMouseLeave}
    >
      <div data-test-id="lockedContainer" onClick={onLockedClick} >
        <_LockedImgBox
          data-test-id="lockedImageBox"
          onClick={
            requireTermsConditionAgreement ? onTermsConditionClick :
              requiredEmailVerification ? openEmailVerifyModal :
                openSignupOnLockedImageClick
          }
        >
          <ImgPreview
            title={title}
            imageUrl={imageSrc}
            locked
            lockedText={
              <ListingPreviewLockedText
                source={source}
                requireTermsConditionAgreement={requireTermsConditionAgreement}
                requiredEmailVerification={requiredEmailVerification}

              />
            }
          />
        </_LockedImgBox>
        <_PreviewContent>
          <_AskingPrice>
            {
              isArchived ? (
                (hiddenFields && hiddenFields.prices)
                  ? 'Price Not Available'
                  : (
                    <_AskingPrice>
                      {closedPrice ? '$' + cn(closedPrice) : 'TBD'}{' '}
                      <BlurCont blur>
                        <span> {'$' + cn(999999)}</span>
                      </BlurCont>
                    </_AskingPrice>
                  )
              ) : (
                <BlurCont blur>
                  {isSold ? infoAskingPrice : '$' + cn(999999)}
                </BlurCont>
              )
            }

          </_AskingPrice>
          <BlurCont blur={(isArchived && !userIsLoggedIn) || requiredEmailVerification}>
            <_AddressHolder>
              {unitNumber && <span>{unitNumber}<_AddressTitle>-</_AddressTitle></span>}
              <_Link
                tabIndex="-1"
                openNewTab={openNewTab}
                to={`/${url}`}
                alt={title}
              >
                <_AddressTitle>
                  {title}
                </_AddressTitle>
              </_Link>
            </_AddressHolder>
          </BlurCont>
          <InfoHolderLocked
            onRegister={openSignupOnListingInfo}
            onLogin={onLogin}
            source={source}
            requireTermsConditionAgreement={requireTermsConditionAgreement}
            onTermsConditionClick={onTermsConditionClick}
            requiredEmailVerification={requiredEmailVerification}
            openEmailVerifyModal={openEmailVerifyModal}
          />
          <_ListingRemovalMessageContainer>
            <ListingRemovalMessage
              showShortMessage
              hideContactAgentText
              hiddenFields={hiddenFields}
              fontSize="sm"
            />
          </_ListingRemovalMessageContainer>

        </_PreviewContent>
      </div>
    </_Locked>
  )
}

Locked.propTypes = {
  url: PropTypes.string.isRequired,
  onLogin: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  onHover: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onRegister: PropTypes.func,
  // lowResImgUrl: PropTypes.string,
  askingPrice: PropTypes.number.isRequired,
  isSold: PropTypes.bool,
  slogan: PropTypes.string,
  building: PropTypes.string,
  unitNumber: PropTypes.number,
  isArchived: PropTypes.bool,
  openNewTab: PropTypes.bool,
  closedPrice: PropTypes.number,
  userIsLoggedIn: PropTypes.bool,
  requiredEmailVerification: PropTypes.bool,
  openEmailVerifyModal: PropTypes.func,
  hiddenFields: PropTypes.shape({
    photos: PropTypes.bool,
    listing_info: PropTypes.bool,
    prices: PropTypes.bool,
  }),
  source: PropTypes.string,
  requireTermsConditionAgreement: PropTypes.bool,
  onTermsConditionClick: PropTypes.func,
}

export default Locked
